import { DEFAULT_BLOCK } from '@@editor/constants';
import { Element, type ParagraphElement } from '@@editor/helpers/Element';

const toParagraph = (element?: Element) =>
    element
        ? ({
              ...DEFAULT_BLOCK,
              ...element,
              type: DEFAULT_BLOCK.type,
              data: DEFAULT_BLOCK.data,
          } as ParagraphElement)
        : Element.create<ParagraphElement>(DEFAULT_BLOCK);

export default toParagraph;
